import { CompetitorData } from '../types/dataTypes';

export const mockData: CompetitorData = {
  yourWebsite: 'https://example.com',
  competitors: [
    { name: 'Competitor1', url: 'https://competitor1.com' },
    { name: 'Competitor2', url: 'https://competitor2.com' },
    { name: 'Competitor3', url: 'https://competitor3.com' }
  ],
  adMetrics: {
    facebook: {
      impressions: {
        you: 125000,
        competitors: [95000, 110000, 75000]
      },
      clicks: {
        you: 3750,
        competitors: [2850, 3300, 2250]
      },
      ctr: {
        you: 3.0,
        competitors: [3.2, 3.0, 3.0]
      },
      cpc: {
        you: 1.25,
        competitors: [1.45, 1.30, 1.10]
      },
      conversions: {
        you: 450,
        competitors: [320, 390, 270]
      },
      insights: [
        'Your Facebook impressions outperform competitors by 15-40%, showing strong campaign reach.',
        'Your conversion rate is 2.5% higher than the industry average.',
        'Competitor 2 has a slightly lower CPC, suggesting room for bid optimization.'
      ]
    },
    linkedin: {
      impressions: {
        you: 45000,
        competitors: [65000, 40000, 30000]
      },
      clicks: {
        you: 1800,
        competitors: [2600, 1600, 1200]
      },
      ctr: {
        you: 4.0,
        competitors: [4.2, 4.0, 4.0]
      },
      cpc: {
        you: 5.75,
        competitors: [5.25, 5.90, 6.10]
      },
      conversions: {
        you: 320,
        competitors: [390, 290, 210]
      },
      insights: [
        'Competitor 1 has 44% higher LinkedIn impressions, suggesting larger campaign investment.',
        'Your LinkedIn CPC is competitive, sitting 9.5% below the industry average.',
        'Conversion opportunity: optimizing LinkedIn campaigns could yield 20% more conversions based on competitor benchmarks.'
      ]
    },
    google: {
      impressions: {
        you: 250000,
        competitors: [220000, 275000, 190000]
      },
      clicks: {
        you: 12500,
        competitors: [11000, 13750, 9500]
      },
      ctr: {
        you: 5.0,
        competitors: [5.3, 5.0, 5.0]
      },
      cpc: {
        you: 2.50,
        competitors: [2.80, 2.35, 2.25]
      },
      conversions: {
        you: 750,
        competitors: [660, 825, 570]
      },
      insights: [
        'Competitor 2 achieves 10% higher Google Ad impressions with only 6% higher spend.',
        'Your Google Ads conversion rate exceeds competitors by an average of 7.8%.',
        'There\'s an opportunity to improve Quality Score - competitors achieve similar results with lower CPCs.'
      ]
    }
  },
  seoMetrics: {
    organicKeywords: 1850,
    avgPosition: 18.3,
    trafficValue: 57500,
    backlinks: 3750,
    topKeywords: [
      { term: 'marketing analytics dashboard', position: 3, volume: 1900, difficulty: 65 },
      { term: 'competitor ad analysis', position: 5, volume: 1400, difficulty: 58 },
      { term: 'social media competitive analysis', position: 7, volume: 2200, difficulty: 72 },
      { term: 'seo competitor tracking', position: 9, volume: 1700, difficulty: 61 },
      { term: 'digital marketing intelligence', position: 12, volume: 2900, difficulty: 79 },
    ]
  },
  insights: {
    messagingAnalysis: {
      summary: 'Analysis of competitor ad copy reveals that your messaging focuses more on technical capabilities while competitors emphasize outcomes and ROI. Your messaging appears more feature-focused while the competition is more benefit-oriented. Consider testing more outcome-based messaging that highlights business impact rather than technical specifications.',
      themes: [
        'Cost Savings',
        'Performance Metrics',
        'Ease of Use',
        'Integration Capabilities',
        'Real-time Analytics',
        'Competitive Insights',
        'ROI Focus'
      ]
    },
    ctaAnalysis: {
      summary: 'Competitor CTAs show a trend toward value-offering language rather than direct conversion requests. Free trials and demos remain popular, but "See how you compare" and "Get insights now" are outperforming traditional CTAs in the industry.',
      popularCtas: [
        { text: 'Start Free Trial', frequency: 0.28 },
        { text: 'See how you compare', frequency: 0.22 },
        { text: 'Get a Demo', frequency: 0.18 },
        { text: 'View Insights', frequency: 0.15 },
        { text: 'Request Analysis', frequency: 0.12 },
        { text: 'Learn More', frequency: 0.05 }
      ]
    },
    positioningAnalysis: {
      summary: 'Your website messaging positions your product as a mid-range solution with a balance of features and pricing. Competitors 1 and 3 are taking a more premium position with emphasis on advanced features and integrations, while Competitor 2 is focusing on simplicity and affordability for smaller businesses.',
      differentiators: [
        'Your platform offers more customizable dashboards than all competitors',
        'Your solution provides the most comprehensive ad platform integrations',
        'You offer more competitive tracking parameters than competitors',
        'Your platform has the fastest data refresh rates in the category'
      ],
      improvements: [
        'Competitor 1 has stronger case studies showing specific ROI results',
        'Competitor 2\'s simpler onboarding process is highlighted in messaging',
        'Competitors emphasize AI-powered insights more prominently',
        'Competitors have more industry-specific solution pages'
      ],
      marketPositions: [
        { name: 'You', xValue: 0.4, yValue: 0.3, isYou: true },
        { name: 'Competitor1', xValue: 0.85, yValue: 0.25, isYou: false },
        { name: 'Competitor2', xValue: 0.2, yValue: 0.6, isYou: false },
        { name: 'Competitor3', xValue: 0.75, yValue: 0.7, isYou: false }
      ]
    }
  }
};